// extracted by mini-css-extract-plugin
module.exports = {"title":"ExpandableRow-module__title--2jFqR","dataContainer":"ExpandableRow-module__dataContainer--11ULR","col1":"ExpandableRow-module__col1--19tHH"};